"use client"

import "./resources-card.less"

import {
  FileText,
  BookOpen,
  HelpCircle,
  Compass,
  ChevronRight,
} from "lucide-react"
import { useToast } from "@/lib/hooks/use-toast"

interface ResourceItem {
  icon: typeof FileText
  label: string
}

const RESOURCES: ResourceItem[] = [
  { icon: FileText, label: "课程文档" },
  { icon: Compass, label: "学习指南" },
  { icon: BookOpen, label: "案例汇编" },
  { icon: HelpCircle, label: "FAQ" },
]

export function ResourcesCard() {
  const toast = useToast()

  const handleResourceClick = (label: string) => {
    toast.info(`「${label}」正在准备中，敬请期待`)
  }

  return (
    <div className="resources-card">
      <h4 className="resources-card__title">学习资源</h4>

      <div className="resources-card__list">
        {RESOURCES.map((res) => {
          const Icon = res.icon
          return (
            <button
              type="button"
              key={res.label}
              onClick={() => handleResourceClick(res.label)}
              className="resources-card__item"
            >
              <div className="resources-card__icon-wrap">
                <Icon className="resources-card__icon" />
              </div>
              <span className="resources-card__label">{res.label}</span>
              <span className="resources-card__trailing">
                <ChevronRight className="resources-card__trailing-icon" />
              </span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
